<div class="request-classification-container">
	<div class="dotted-input-container" *ngIf="availableClassification.solutionArea.length > 0 && !hideField.includes('solutionArea')">
		<span>{{ labels.lbl_geral_grupo }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.solutionAreaIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.solutionArea[0]?.id"
			[setInputText]="selectedClassification.solutionArea[0]?.name"
			[disabled]="lockField?.includes('solutionArea') || _isLoadingNextStep"
			(getIndex)="setClassification('solutionArea', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.solutionArea[0] != undefined &&
			availableClassification.serviceType.length > 0 &&
			!hideField.includes('serviceType')
		">
		<span>{{ labels.lbl_chamado_tipo_servico }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.serviceTypeIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.serviceType[0]?.id"
			[setInputText]="selectedClassification.serviceType[0]?.name"
			[disabled]="lockField?.includes('serviceType') || _isLoadingNextStep"
			(getIndex)="setClassification('serviceType', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.serviceType[0] != undefined && availableClassification.scope.length > 0 && !hideField.includes('scope')
		">
		<span>{{ labels.lbl_geral_competencia }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.scopeIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.scope[0]?.id"
			[setInputText]="selectedClassification.scope[0]?.name"
			[disabled]="lockField?.includes('scope') || _isLoadingNextStep"
			(getIndex)="setClassification('scope', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.scope[0] != undefined && availableClassification.category.length > 0 && !hideField.includes('category')
		">
		<span>{{ labels.lbl_geral_natureza }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.categoryIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.category[0]?.id"
			[setInputText]="selectedClassification.category[0]?.name"
			[disabled]="lockField?.includes('category') || _isLoadingNextStep"
			(getIndex)="setClassification('category', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="selectedClassification.category[0] != undefined && availableClassification.topic.length > 0 && !hideField.includes('topic')">
		<span>{{ labels.lbl_geral_topico }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.topicIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.topic[0]?.id"
			[setInputText]="selectedClassification.topic[0]?.name"
			[disabled]="lockField?.includes('topic') || _isLoadingNextStep"
			(getIndex)="setClassification('topic', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="selectedClassification.topic[0] != undefined && availableClassification.impact.length > 0 && !hideField.includes('impact')">
		<span>{{ labels.lbl_geral_impacto }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.impactIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.impact[0]?.id"
			[setInputText]="selectedClassification.impact[0]?.label"
			[disabled]="lockField?.includes('impact') || _isLoadingNextStep"
			(getIndex)="
				setClassification('impact', $event, false);
				selectedClassification.impact[0] != undefined && selectedClassification.urgency[0] != undefined ? setSeverity() : null
			">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.topic[0] != undefined && availableClassification.urgency.length > 0 && !hideField.includes('urgency')
		">
		<span>{{ labels.lbl_geral_urgencia }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.urgencyIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.urgency[0]?.id"
			[setInputText]="selectedClassification.urgency[0]?.label"
			[disabled]="lockField?.includes('urgency') || _isLoadingNextStep"
			(getIndex)="
				setClassification('urgency', $event, false);
				selectedClassification.impact[0] != undefined && selectedClassification.urgency[0] != undefined ? setSeverity() : null
			">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.impact[0] != undefined &&
			selectedClassification.urgency[0] != undefined &&
			availableClassification.severity.length > 0 &&
			!hideField.includes('severity')
		">
		<span>{{ labels.lbl_geral_severidade }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.severityIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="selectedClassification.severity[0]?.id"
			[setInputText]="selectedClassification.severity[0]?.name"
			[disabled]="lockField?.includes('severity') || _isLoadingNextStep"
			(getIndex)="setClassification('severity', $event, true)">
		</cpi-input-with-autocomplete>
	</div>

	<div
		class="dotted-input-container"
		*ngIf="
			selectedClassification.serviceType[0]?.name === 'Change' &&
			selectedClassification.topic[0] != undefined &&
			!hideField.includes('riskType')
		">
		<span>{{ this.labels.lbl_geral_tipo_de_risco }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="availableClassification.riskTypeIAC"
			[placeholder]="''"
			[minInputLength]="0"
			[setValue]="+selectedClassification.riskType[0]?.id"
			[setInputText]="selectedClassification.riskType[0]?.name"
			[disabled]="lockField?.includes('riskType') || _isLoadingNextStep"
			(getIndex)="setClassification('riskType', $event, false)">
		</cpi-input-with-autocomplete>
	</div>

	<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="_isLoadingNextStep"></cpi-dot-bounce-loading-effect>
</div>
